<div
  class="flex-row-container flex-row-container--v-center flex-row-container--center direction-container"
  [ngStyle]="{ 'width.px': coachDetails.floorplanDimensions.width }"
>
  @if (isLeftDirection) {
    <fa-icon
      [icon]="faAngleLeft"
      ngbTooltip="Travelling left"
      attr.aria-label="Travelling left"
    ></fa-icon>
  } @else {
    <fa-icon
      [icon]="faAngleRight"
      ngbTooltip="Travelling right"
      attr.aria-label="Travelling right"
    ></fa-icon>
  }
  <span i18n="@@travelDirection"> Direction of travel </span>
</div>

@if (coachDetails && coachDetails.imageTemplate && imageLoadedCorrectly && !loadingImage) {
  <div
    class="seatmap-container"
    [ngStyle]="{
      'width.px': coachDetails.floorplanDimensions.width,
      'height.px': coachDetails.floorplanDimensions.height,
      'background-image': 'url(' + seatMapUrl + ')'
    }"
  >
    @for (seat of coachDetails.seats; track seat) {
      <button
        (click)="chooseSeat(seat)"
        class="seat"
        [ngStyle]="
          seatMapReversed
            ? {
                'width.px': coachDetails.seatWidth,
                'height.px': coachDetails.seatHeight,
                'right.px': seat.xPos,
                'bottom.px': seat.yPos
              }
            : {
                'width.px': coachDetails.seatWidth,
                'height.px': coachDetails.seatHeight,
                'left.px': seat.xPos,
                'top.px': seat.yPos
              }
        "
        [ngClass]="{
          'selectable-seat': seat.isBookable,
          'chosen-seat': chosenSeatIdsObject[seat.id],
          'selectable-seat-blocked':
            (!seat.isBookable ||
              seat.isBlocked ||
              releventLeg.inventoryClass !== seat.inventoryClass) &&
            !reservedSeatIds[seat.id] &&
            !chosenSeatIdsObject[seat.id],
          'selectable-seat-reserved': reservedSeatIds[seat.id]
        }"
        [disabled]="
          (!seat.isBookable ||
            seat.isBlocked ||
            releventLeg.inventoryClass !== seat.inventoryClass) &&
          !reservedSeatIds[seat.id]
        "
        [ngbTooltip]="seat.id"
        [attr.aria-pressed]="chosenSeatIdsObject[seat.id] ? 'true' : 'false'"
      >
        @if (isLeftDirection) {
          @if (inboundDirectionSeats[seat.id]) {
            <fa-icon aria-hidden="true" [icon]="faSeatAirline"></fa-icon>
          } @else if (outboundDirectionSeats[seat.id]) {
            <fa-icon aria-hidden="true" [icon]="faSeatAirline" class="fa-flip-horizontal"></fa-icon>
          }
        } @else {
          @if (outboundDirectionSeats[seat.id]) {
            <fa-icon aria-hidden="true" [icon]="faSeatAirline"></fa-icon>
          } @else if (inboundDirectionSeats[seat.id]) {
            <fa-icon aria-hidden="true" [icon]="faSeatAirline" class="fa-flip-horizontal"></fa-icon>
          }
        }

        <span class="visuallyhidden"
          >Select seat at {{ seat.rowNumber }} {{ seat.rowPosition }}</span
        >
      </button>
    }
  </div>
} @else if (
  ((!coachDetails.imageTemplate && coachDetails) || !imageLoadedCorrectly) && !loadingImage
) {
  <span class="error">Seatmap for coach {{ coachDetails.id }} not available</span>
} @else if (loadingImage) {
  <span class="loading">Loading...</span>
}
